const financialServiceProvider = {
  CONTROLLE: 'CONTROLLE',
  GRANATUM: 'GRANATUM'
};

module.exports = financialServiceProvider;
